import { useContext, useEffect, useRef } from 'react';
import { Button, Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import Regex from "../../../Utilities/Regex";
import { PromisedDonerHistoryContext } from '../PromisedDonerComponent';
import { promisedToCollectionAction } from '../../../Redux/Action/AgentAction';
import Auth from '../../../Utilities/Auth';

function PromisedToDonation(props) {
    // ref
    const btnRef = useRef()
    const dispatch = useDispatch()

    const { watch, control, register, handleSubmit, getValues, reset, setValue, formState: { errors } } = useForm();

    // Context
    const {
        promisedDonerHistory,
        setPromisedDonerHistory,
        promisedToCollectionModelShow,
        setPromisedToCollectionModelShow,
        promisedToCollectionSingle,
        setPromisedToCollectionSingle,
        promisedReload,
        setPromisedReload,
        setPromiseEditModal,
        setPromiseDeleteModal
    } = useContext(PromisedDonerHistoryContext)



    const onSubmit = data => {
        const payload = {
            data: {
                ...data,
                promised_collection_id: promisedToCollectionSingle.id
            },
            setPromisedToCollectionSingle,
            setPromisedToCollectionModelShow,
            setPromisedDonerHistory,

        }
        dispatch(promisedToCollectionAction(payload))
    }



    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} className='donation'>
                <Row>





                    <Col md={12} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Paymeny type</Form.Label>
                            <Form.Select
                                aria-label="Default select example"
                                {...register("paymeny_type", { required: true })}
                                defaultValue=""  // ensures the first option is shown initially
                            >
                                <option value="" disabled>
                                    Select
                                </option>
                                <option value="Cash">Cash</option>
                                <option value="Online Pay">Online Pay</option>
                                <option value="Check">Check </option>

                            </Form.Select>

                            {/* validation message*/}
                            {errors.paymeny_type && <span className="text-danger">
                                {errors.paymeny_type.type === "required" && "Please select type"}
                            </span>}
                        </Form.Group>
                    </Col>


                </Row>
                <Button ref={btnRef} variant="primary" type="submit" className="submit">
                    Submit
                </Button>

            </form >
        </>
    );
}

export default PromisedToDonation;